import { createContext } from 'react';
import { WEB_PARTITION } from '@/types';

type PartitionContextType = {
  partition: WEB_PARTITION;
  setPartition: (partition: WEB_PARTITION) => void;
};

export const PartitionContext = createContext<PartitionContextType>({
  partition: WEB_PARTITION.MPA,
  setPartition: () => {},
});
